export default __webpack_public_path__ + "static/media/p9.ecd2887c.png";